import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon'
import { hoverSelector } from '../../styles'

const Styled = styled.div``
Styled.input = styled.input`
  display: none;
`
Styled.starStroke = styled(({ isHidden, ...rest }) => <Icon {...rest} />)`
  position: absolute;
  left: 0.8rem;
  top: 0;
  width: 3.2rem;
  height: 3.2rem;
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ isHidden }) => (isHidden ? '0' : '1')};
`
Styled.starFill = styled(({ isHidden, ...rest }) => <Icon {...rest} />)`
  position: absolute;
  left: 0.8rem;
  top: 0;
  width: 3.2rem;
  height: 3.2rem;
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ isHidden }) => (isHidden ? '0' : '1')};
`
Styled.stars = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${hoverSelector(Styled.starFill)`
    opacity: 1;
  `}
`
Styled.label = styled.label`
  width: 4.8rem;
  height: 3.2rem;
  padding: 0 0.8rem;
  position: relative;
  cursor: pointer;
  margin: 0;
  ${hoverSelector(`~ & ${Styled.starStroke}`)`
    opacity: 1;
  `}
  ${hoverSelector(`~ & ${Styled.starFill}`)`
    opacity: 0;
  `}
`

export default Styled
